import MainPageLayout from 'layouts/MainPageLayout';
import { FormattedMessage } from 'react-intl';
import DisconnectButton from './Profile/DisconnectButton';
import RelationshipManagement from './Profile/RelationshipManagement';
import OnBoardingReplay from './Profile/OnBoardingReplay';

const Profile = (): JSX.Element => (
  <MainPageLayout title={<FormattedMessage id="profile.title" />}>
    <DisconnectButton />

    <RelationshipManagement />

    <OnBoardingReplay />
  </MainPageLayout>
);

export default Profile;
